import { useTranslation } from 'react-i18next';
import { Search, ChevronRight, ExternalLink } from 'lucide-react';
import { TranslatedCalling } from './common';

function SearchWebResult({
  toolCall,
  expanded,
  setExpanded,
}: {
  toolCall: any;
  expanded: boolean;
  setExpanded: (fn: (v: boolean) => boolean) => void;
}) {
  const { t } = useTranslation('chat');
  const result = toolCall.result || {};
  const results = result.results || [];
  const query = result.query || '';
  const hasResults = Array.isArray(results) && results.length > 0;

  return (
    <div className="my-4">
      <div className="flex items-center cursor-pointer select-none" onClick={() => setExpanded((v: boolean) => !v)}>
        <div className="text-xs text-gray-400 font-light flex items-center gap-1">
          <Search className="w-3 h-3" />
          {t('tool.search-web.searched')}
        </div>
        <ChevronRight
          className={`ml-2 w-3 h-3 text-gray-400 transition-transform duration-200 ${
            expanded ? 'rotate-90' : 'rotate-0'
          }`}
        />
      </div>
      {expanded && (
        <div className="mt-3 ml-4">
          <div className="text-xs text-gray-600 mb-3">"{query}"</div>
          {hasResults ? (
            <div className="space-y-2">
              {results.map((item: any, index: number) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-gray-50 hover:bg-gray-100 text-gray-700 text-xs px-3 py-2 rounded border border-gray-200 transition-colors"
                >
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex-1 min-w-0">
                      <div className="font-medium mb-1 truncate">{item.title}</div>
                      <div className="text-gray-500 line-clamp-2">{item.snippet}</div>
                    </div>
                    <ExternalLink className="w-3 h-3 text-gray-400 flex-shrink-0 mt-0.5" />
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <div className="text-gray-500 text-xs">{t('tool.search-web.no-results')}</div>
          )}
        </div>
      )}
    </div>
  );
}

export const search_web = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.search-web.searching" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.search-web.searching-short" />,
  result: ({ toolCall, expanded, setExpanded }: any) => (
    <SearchWebResult toolCall={toolCall} expanded={expanded} setExpanded={setExpanded} />
  ),
};
